import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SystemApiClient } from "../clients/system-api/SystemApiClientp";
import { PaginationArgs, HolidayDataPaginationDataAdministrationResult, HolidayData, AdministrationResultStatus } from "../clients/system-api/SystemApiClient";

@Injectable({
    providedIn: 'root'
  })
  export class HolidayService {
    constructor (private systemApiClient: SystemApiClient) { }

    retrieveAllHolidays(body: PaginationArgs | undefined): Observable<HolidayDataPaginationDataAdministrationResult>{
        return this.systemApiClient.retrieveAllHolidays(body);
    }

    addHoliday(body: HolidayData | undefined): Observable<AdministrationResultStatus>    {
        return this.systemApiClient.addHoliday(body);
    }

    editHoliday(body: HolidayData | undefined): Observable<AdministrationResultStatus>{

        return this.systemApiClient.editHoliday(body);
    }

    retriveHolidayById(holidayId: number): Observable<AdministrationResultStatus>{
        return this.systemApiClient.retriveHolidayById(holidayId);
    }
}